import {register} from '@shopify/theme-sections';

import ModalDialog from '../components/modal-dialog';

const selectors = {
  returnButton: '[data-return-btn]',
  signupModalTrigger: '[data-modal-signup-trigger]',
  signupModal: '[data-modal-signup]',
};

const sectionType = 'footer';
const registeredSections = window.Shopify?.theme?.sections?.registered || {};
const isUnregistered = typeof registeredSections[sectionType] === 'undefined';

export default isUnregistered &&
  register(sectionType, {
    onLoad() {
      const container = this.container;

      const returnButton = container.querySelector(selectors.returnButton);
      if (returnButton) {
        returnButton.addEventListener('click', () => history.back());
      }

      const signupModalEl = document.querySelector(selectors.signupModal);
      const signupModalTriggers = document.querySelectorAll(selectors.signupModalTrigger);

      if (signupModalEl && signupModalTriggers.length > 0) {
        // eslint-disable-next-line no-unused-vars
        const signupModal = new ModalDialog(signupModalEl, {
          triggerEl: signupModalTriggers,
          modalId: 'signup',
        });
      }
    },
  });
